import { object, string } from "yup";
import PageBlock from "@page-js/Pages/Page/Editor/scripts/pageBlock";

export default class RichText extends PageBlock {
  public getType(): string {
    return "RichText";
  }

  protected init(): any {
    return {
      props: {
        html: "여기에 텍스트를 입력해 주세요",
      },
      attrs: {},
    };
  }

  public validateOrThrow(): Promise<any> {
    const schema = object().shape({
      props: object()
        .shape({
          html: string().max(5000).required().label("HTML 내용"),
        })
        .label("옵션"),
      attrs: object().required().label("속성"),
    });

    return schema.validate(this.toJSON(), { abortEarly: false });
  }
}
